export default __webpack_public_path__ + "static/media/art-face.5ac62485.jpg";